import { Input } from "components/common/Input/Input";
import { useSize } from "./useSize";
import { capitalize } from "client/utils/capitalize";
import { UnitDropDown } from "components/modules/Editors/ImageResizer/EditSettings/ResizeSettings/Size/Size";
import { useUnit } from "../Unit/useUnit";
import { Translate } from "components/common/Translate/Translate";
import { translateFunc } from "client/utils/translateFunc";
import { Checkbox } from "components/common/Checkbox/Checkbox";
import { roundDimension } from "store/features/resizeEditor/utils/roundDimension";

export const BulkResizerSize = () => {
    const { height, width, handleHeightChange, handleWidthChange, isLocked, toggleLock, unit } = useSize();
    const { handleChange: handleUnitChange } = useUnit();
    const finalWidth = roundDimension(unit, width ?? 0);
    const finalHeight = roundDimension(unit, height ?? 0);

    return (
        <div className="flex flex-col gap-4">
            <div className="flex max-w-full items-end gap-2">
                <div className="flex-grow flex flex-col min-w-0 gap-2">
                    <div className="capitalize pb-2" data-testid={`width-input-label`}>
                        <Translate keyName="width" />
                    </div>
                    <Input
                        type="number"
                        acceptFloat={unit !== "pixels"}
                        value={finalWidth || ""}
                        placeholder={capitalize(translateFunc("enter-width"))}
                        min={0}
                        onChange={handleWidthChange}
                        data-testid={`width-input`}
                    />
                </div>
                <div className="flex-grow flex flex-col min-w-0 gap-2">
                    <div className="flex items-center justify-between min-w-0 gap-2">
                        <div className="capitalize" data-testid={`height-input-label`}>
                            <Translate keyName="height" />
                        </div>
                        <UnitDropDown unit={unit} handleChange={handleUnitChange} />
                    </div>
                    <Input
                        type="number"
                        acceptFloat={unit !== "pixels"}
                        value={finalHeight || ""}
                        min={0}
                        placeholder={capitalize(translateFunc("enter-height"))}
                        onChange={handleHeightChange}
                        data-testid="height-input"
                    />
                </div>
            </div>
            <div className="flex justify-between items-center">
                <Checkbox
                    defaultIsChecked={isLocked}
                    handleChange={toggleLock}
                    label={capitalize(translateFunc("lock-aspect-ratio"))}
                    testId="lock-container"
                />
            </div>
        </div>
    );
};
